import * as types from "./types";

export const showCreateForm = () => ({
  type: types.SHOW_CREATE_FORM
});

export const hideCreateForm = () => ({
  type: types.HIDE_CREATE_FORM
});



// WEBPACK FOOTER //
// ./src/modules/payment/actions.js